<template>
  <picture class="buynow-logo">
    <img v-bind:style="logoStyle" src="@/assets/logo/buynow-basic.svg" alt="BUYNOW logo" />
  </picture>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: '30px',
    },
    white: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    logoStyle() {
      return {
        width: this.width,
        objectFit: 'contain',
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.buynow-logo {
  line-height: 1;

  img {
    vertical-align: middle;
  }
}
</style>
